import type { ReminderItem } from '../../../hooks/use-reminders'

/**
 * Pinning is the wire field `priority`, read straight.
 *
 * The two used to be separate: the backend ranked reminders on its own and
 * `manualPriority` was the user's lock over that ranking, with pinning riding
 * on top of it. Auto-prioritization is off, so nothing but the user writes
 * `priority` any more and the lock has no ranking left to override — one flag,
 * one control, called what it does.
 */
export function isPinnedReminder(item: Pick<ReminderItem, 'priority'>): boolean {
  return item.priority === true
}
